export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div
        className="h-10 w-10 animate-spin rounded-full border-4"
        style={{ borderColor: '#ffd484', borderTopColor: 'transparent' }}
      />
    </div>
  );
}
